<template>
    <v-dialog v-model="dialog" max-width="900" persistent>
        <v-card>
            <v-card-title class="primary white--text title">
                {{ 'Parameter auto-tuner'|translate }}
            </v-card-title>
            <v-card-text class="pr-4 pl-4">
                <v-text-field :label="'Name'|translate" v-model="name"></v-text-field>
                <v-switch color="success" :label="'Active'|translate" v-model="active"></v-switch>
                <sensor-selector :label="'Target'|translate" v-model="target"></sensor-selector>
                <v-text-field :label="'Adjustment Frequency'|translate" v-model.number="adjustment_frequency"></v-text-field>
                <v-slider
                    :label="'Exploit - Explore'|translate" v-model.number="config.exploit_explore"
                    :min="0"
                    :max="1"
                    :step="0.01"
                    thumb-label
                ></v-slider>
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-card-title class="accent white--text subheading">
                            {{ 'Parameters'|translate }}
                            <v-spacer></v-spacer>
                            <v-icon class="mr-2" small @click="addParameter">fa-plus</v-icon>
                        </v-card-title>
                    </v-flex>
                    <v-flex xx12 v-for="(parameter, parameterindex) in config.parameters">
                        <v-layout row>
                            <v-flex xs5 class="pa-2">
                                <sensor-selector v-model="parameter.sensor"
                                              :label="'Sensor'|translate" ></sensor-selector>
                            </v-flex>
                            <v-flex xs3 class="pa-2">
                                <v-text-field v-model.number="parameter.min" type="number"
                                              :label="'Min'|translate"></v-text-field>
                            </v-flex>
                            <v-flex xs3 class="pa-2">
                                <v-text-field v-model.number="parameter.max" type="number"
                                              :label="'Max'|translate"></v-text-field>
                            </v-flex>
                            <v-flex xs1 class="pa-2">
                                <v-icon small class="ml-4 mt-4" @click="removeParameter(parameterindex)">fa-trash</v-icon>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-card-title class="accent white--text subheading">
                            {{ 'Covariants'|translate }}
                            <v-spacer></v-spacer>
                            <v-icon class="mr-2" small @click="addCovariant">fa-plus</v-icon>
                        </v-card-title>
                    </v-flex>
                    <v-flex xx12 v-for="(covariant, covariantindex) in config.covariants">
                        <v-layout row>
                            <v-flex xs11 class="pa-2">
                                <sensor-selector v-model="covariant.sensor"
                                                 :label="'Sensor'|translate" ></sensor-selector>
                            </v-flex>
                            <v-flex xs1 class="pa-2">
                                <v-icon small class="ml-4 mt-4" @click="removeCovariant(covariantindex)">fa-trash</v-icon>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="primary" @click="addRecord()" :disabled="!$can('update', 'Autotuner')">
                    {{ 'Save'|translate }}
                </v-btn>
                <v-btn @click="dialog=false">{{ 'Cancel'|translate }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import {putAutotuner} from '../helper'
import SensorSelector from "@/components/SensorSelector";

export default {
    props: {
        value: {type: Boolean, default: true},
        item: {type: Object, default: null}
    },
    components: {SensorSelector},
    watch: {
        item(item) {
            this.initializeVar()
            if (item) {
                let newItem=JSON.parse(JSON.stringify(item))
                this.autotuner_id = newItem['autotuner_id']
                this.name = newItem['name']
                this.active = newItem['active']
                this.target = newItem['target']
                this.config = newItem['config']
                this.adjustment_frequency = newItem['adjustment_frequency']
            }
        },
        value() {
            if (this.dialog != this.value) {
                this.dialog = this.value
            }
        },
        dialog() {
            this.$emit('input', this.dialog)
        }
    },
    data() {
        return {
            dialog: false,
            autotuner_id: null,
            name: null,
            active: false,
            target: null,
            config: {
                prameters:[],
                covariants:[],
                exploit_explore:0.2,
            },
            adjustment_frequency: 4,
        }
    },
    methods: {
        addParameter() {
            this.config.parameters.push({min:-10, max:10, sensor:null})
        },
        removeParameter(index) {
            this.config.parameters.splice(index, 1)
        },
        addCovariant() {
            this.config.covariants.push({sensor:null})
        },
        removeCovariant(index) {
            this.config.covariants.splice(index, 1)
        },
        initializeVar() {
            this.autotuner_id = null
            this.name = null
            this.active = false
            this.target = null
            this.config = {
                parameters:[],
                covariants:[],
                exploit_explore:0.2,
            }
            this.adjustment_frequency = 4
        },
        async addRecord() {
            let config=JSON.parse(JSON.stringify(this.config))
            config.parameters=config.parameters.filter(x=>x.sensor&&x.sensor!=="")
            config.covariants=config.covariants.filter(x=>x.sensor&&x.sensor!=="")
            await putAutotuner(
                {
                    'autotuner_id': this.autotuner_id,
                    'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                    'name': this.name,
                    'active': this.active,
                    'target': this.target,
                    'config': config,
                    'adjustment_frequency': this.adjustment_frequency,
                }
            )
            this.$emit('doreload')
            this.dialog = false
        }
    },
    name: 'AutotunerDialog'
}
</script>

<style scoped>

</style>
